import axios from 'axios';
import { axiosInstance } from '../interceptor';

const API_URL =`${process.env.REACT_APP_API_URL}`
//  `${process.env.REACT_APP_API_URL}custom`




export const rechargeWallet = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}payment/rechargeWalletAdmin`, {
      data,
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching wallets:', error);
    throw error;  // Re-throw the error so that calling function can handle it
  }
};
